// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NHZZu","importantInfo":"styles_importantInfo__22ynW"};